// extracted by mini-css-extract-plugin
module.exports = {"root":"PerkProgress_root__3wBOK","progressSection":"PerkProgress_progressSection__IzQN8"};